import { CCol, CInput, CLabel, CRow, CSelect } from "@coreui/react";
import { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import FilterSection from "src/views/common/controller/FilterSection";

const SearchFilter = (props) => {
  const [itemsCollectionSeason, setItemsCollectionSeason] = useState([]);
  const [itemsTenderNo, setItemsTenderNo] = useState([]);
  const [itemsCircle, setItemsCircle] = useState([]);
  const [itemsDistrict, setItemsDistrict] = useState([]);

  useEffect(() => {
    getTenderCollectionSeasonDrop();
    getTenderDetails();
    getCircleList();
      if (props.search.circleId > 0) {
        getDistrictList(props.search.circleId);
      }
      else
      {
        getDistrictList();
      }
  }, [props.isClear,props.search.circleId]);

  const getTenderCollectionSeasonDrop = async () => {
    await apiCallResponse(`Tender/GetTenderCollectionSeason`).then((res) => {
      if (res.success) setItemsCollectionSeason(res.data);
      else setItemsCollectionSeason([]);
    });
  };
  const getTenderDetails = async (tenderCollectionSeasonSearch = "") => {
    let filter = "";

    if (
      tenderCollectionSeasonSearch !== "" &&
      tenderCollectionSeasonSearch !== undefined
    ) {
      filter =
        "&$filter=contains(collectionSeason,'" +
        tenderCollectionSeasonSearch +
        "')";
    }
    await apiCallResponse(`Tender?$orderBy=tenderNo%20desc${filter}`).then(
      (res) => {
        if (res.success) setItemsTenderNo(res.data);
        else setItemsTenderNo([]);
      }
    );
  };

  // const getCircleList = async () => {
  //   await apiCallResponse(`Circle_Master`).then((res) => {
  //     if (res.success) setItemsCircle(res.data);
  //     else setItemsCircle([]);
  //   });
  // };

  const getCircleList = async () => {
    await apiCallResponse("Circle_Master").then((res) => {
        if (res.success) {
            console.log("Circle API response:", res.data);

            console.log(
                "Invalid circle records:",
                res.data?.filter(x => !x?.name)
            );

            setItemsCircle(res.data);
        } else {
            setItemsCircle([]);
        }
    });
};

  const getDistrictList = async (circleId = 0) => {
    let filter = "";

    if (circleId !== "" && circleId !== undefined && parseInt(circleId) > 0) {
      filter = "&$filter= circleId eq " + circleId;
    }
    await apiCallResponse(`District_Master?${filter}`, "GET").then((res) => {
      if (res.success) setItemsDistrict(res.data);
      else setItemsDistrict([]);
    });
  };
  const handleChangeTenderCollectionSeason = (e) => {
    const value = e.target.value;
    props.updateSearch(e, "tenderId", 0);
    setItemsTenderNo([]);
    getTenderDetails(value);
  };
  const handleChangeCircle = (e, id) => {
    const value = e.target.value;
    props.updateSearch(e, "disctrictId", 0);
    setItemsDistrict([]);
    getDistrictList(value);
  };

  // Function to handle date changes
  const handleDateChange = (event) => {
    console.log("handleDateChange", event);
    const inputDate = event.target.value;
    //if (event.key === "Tab") {
    // Check if the input date is not empty and if it is valid
    if (inputDate.trim() !== "" && !isValidDate(inputDate)) {
      // Handle invalid date input, such as showing an error message
      console.error("Invalid date format : ", inputDate);
      //alert("Invalid date format");
      // Reset the input value
      event.target.value = "";
      // Optionally reset the selected date state
      // setSelectedDate("");
    } else {
      props.updateSearch(event); // or whatever function you need to call when the date changes
    }
    // } else {
    //   alert("next");
    //   // if (inputDate.trim() !== "" && !isValidDate(inputDate)) {
    //   //   // Handle invalid date input, such as showing an error message
    //   //   console.error("Invalid date format");
    //   //   alert("Invalid date format");
    //   //   setSelectedDate(null);

    //   //   // Reset the input value
    //   //   event.target.value = "";
    //   //   // Optionally reset the selected date state
    //   //   setSelectedDate(null);
    //   // } else {
    //   //   setSelectedDate(inputDate);
    //   //   props.updateSearch(event); // or whatever function you need to call when the date changes
    //   // }
    // }
  };

  // // Function to validate the input date
  // const isValidDate = (dateString) => {
  //   console.log("isValidDate : ", dateString);
  //   const regex = /^\d{4}-\d{2}-\d{2}$/;
  //   if (!regex.test(dateString)) return 22;

  //   const date = new Date(dateString);
  //   return !isNaN(date.getTime()) ? true : 11;
  // };
  // Function to validate the input date
  const isValidDate = (dateString) => {
    console.log("isValidDate ddd", dateString);
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    const date = new Date(dateString);
    return !isNaN(date.getTime());
  };
  // Function to handle keydown events
  const handleKeyDown = (event) => {
    // Check if the pressed key is not among the allowed characters for a date format
    // const allowedKeys = [
    //   "0",
    //   "1",
    //   "2",
    //   "3",
    //   "4",
    //   "5",
    //   "6",
    //   "7",
    //   "8",
    //   "9",
    //   "-",
    //   "/",
    // ];
    // console.log("dddd", event.key, event.target.value);
    // if (!allowedKeys.includes(event.key)) {
    //   //event.preventDefault();
    // } else {
    //   // If the key is allowed, construct the potential new date string
    //   const inputDate = event.target.value + event.key;
    //   // Check if the input date is valid
    //   if (!isValidDate(inputDate)) {
    //     //event.preventDefault();
    //   }
    // }
  };
  const handleBlur = (event) => {
    const inputDate = event.target.value;
    console.log("handleBlur ddd", inputDate);
    // Check if the input date is valid
    if (!isValidDate(inputDate)) {
      // Handle invalid date input, such as showing an error message
      console.error("Invalid date format");
      alert("Invalid date format");
      // Reset the input value
      event.target.value = "";
      // Optionally reset the selected date state
    } else {
      // If the date is valid, update the selected date state

      props.updateSearch(event);
    }
  };
  // // Function to handle blur events
  // const handleBlur = (event) => {
  //   const inputName = event.target.name;
  //   const inputDate = event.target.value;
  //   // Check if the input date is valid

  //   console.log("handleBlur inputDate 2: ", inputName, inputDate);
  //   console.log("handleBlur inputDate : ", isValidDate(inputDate));
  //   if (isValidDate(inputDate) === 22) {
  //     alert("Invalid date format");
  //     setSelectedDate(null);
  //     event.target.value = null;
  //     // Handle invalid date input, such as showing an error message
  //   } else {
  //     console.log("handleBlur inputDate : ", inputDate);
  //     setSelectedDate(inputDate);
  //     props.updateSearch(event);
  //     //props.search.date;
  //   }
  // };
  // // Function to prevent typing into the input field
  // const handleKeyDown = (event) => {
  //   //event.preventDefault();
  //   const inputDate = event.target.value;
  //   console.log("handleKeyDown", inputDate);
  //   if (inputDate.length >= 10) {
  //     if (isValidDate(inputDate)) {
  //       setSelectedDate(inputDate);
  //       props.updateSearch(event); // or whatever function you need to call when the date changes
  //     } else {
  //       // Handle invalid date input, such as showing an error message
  //       console.error("Invalid date");
  //       // Optionally reset the input value
  //       // setSelectedDate("");
  //     }
  //   }
  // };
  return (
    <div>
      <CRow>
        <CCol xl={3} sm={6}>
          <CLabel>Collection Season:</CLabel>

          <CSelect
            required
            aria-label="Default select example"
            id="collectionSeason"
            name="collectionSeason"
            value={props.search.collectionSeason}
            onChange={handleChangeTenderCollectionSeason}
          >
            <option value="">Select Collection Season</option>
            {itemsCollectionSeason.map((item, key) => (
              <option key={key} value={item.collectionSeason}>
                {item.collectionSeason}
              </option>
            ))}
          </CSelect>
        </CCol>
        <CCol xl={3} sm={6}>
          <CLabel>Select Tender Number : </CLabel>
          <CSelect
            required
            aria-label="Default select example"
            id="tenderNo"
            name="tenderNo"
            value={props.search.tenderNo}
            onChange={props.updateSearch}
          >
            <option value="">Select Tender Number</option>
            {itemsTenderNo
              //.sort((a, b) => b.tenderNo - a.tenderNo)
              .map((item, key) => (
                <option key={key} value={item.tenderNo}>
                  {item.tenderNo}
                </option>
              ))}
          </CSelect>
        </CCol>
        {(props.searchCircleDisplay === null ||
          props.searchCircleDisplay !== false) && (
          <CCol xl={3} sm={6}>
            <CLabel>Circle Name :</CLabel>
            <CSelect
              id="circleId"
              name="circleId"
              value={props.search.circleId}
              aria-label="Default select example"
              onChange={handleChangeCircle}
            >
              <option value="">Select Circle</option>
              {(itemsCircle || [])
                .sort((a, b) => 
                {
                //      console.log("SORT A:", a);
                // console.log("SORT B:", b);

                  (a?.name || "").localeCompare(b?.name || "")
                })
                .map((item, key) => (
                  <option key={key} value={item.circleId}>
                    {item.name}
                  </option>
                ))}
            </CSelect>
          </CCol>
        )}
        {(props.searchDisctrictDisplay === null ||
          props.searchDisctrictDisplay !== false) && (
          <CCol xl={3} sm={6}>
            <CLabel> Disctrict :</CLabel>
            <CSelect
              id="disctrictId"
              name="disctrictId"
              aria-label="Default select example"
              value={props.search.disctrictId}
              onChange={props.updateSearch}
            >
              <option value="">Select District Union</option>
              {itemsDistrict
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item, key) => (
                  <option key={key} value={item.districtId}>
                    {item.name}
                  </option>
                ))}
            </CSelect>
          </CCol>
        )}
        <CCol xl={3} sm={6}>
          <CLabel>Lot number: </CLabel>{" "}
          <CInput
            id="lotNo"
            name="lotNo"
            value={props.search.lotNo}
            onChange={props.updateSearch}
          />
        </CCol>
        {props.searchQtyDifferDisplay === true && (
          <CCol xl={3} sm={6}>
            <CLabel> Quantity Difference :</CLabel>
            <CSelect
              id="quantityDifferenceId"
              name="quantityDifferenceId"
              aria-label="Default select example"
              value={props.search.quantityDifferenceId}
              onChange={props.updateSearch}
            >
              <option value="">Select Quantity Difference</option>
              <option value="1">Actual Quantity &lt; Estimated Quantity</option>
              <option value="2">
                Actual Quantity &gt;= Estimated Quantity
              </option>
            </CSelect>
          </CCol>
        )}
        {props.searchDateDisplay === true && (
          <CCol xl={3} sm={6}>
            <CLabel> Date :</CLabel>
            <CInput
              type="date"
              placeholder=""
              id="date"
              name="date"
              //value={selectedDate === null ? "" : selectedDate}
              onChange={handleDateChange}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur} // Add onBlur event handler
              value={props.search.date === null ? "" : props.search.date}
              // onChange={props.updateSearch}
            />
          </CCol>
        )}
        {/* {props.searchPaymentTypesDisplay === true && (
          <CCol xl={3} sm={6}>
            <CLabel>Payment Types :</CLabel>
            <CSelect
              id="paymentTypes"
              name="paymentTypes"
              aria-label="Default select example"
              value={props.search.paymentTypes}
              onChange={props.updateSearch}
            >
              <option value="">Select Payment Types</option>
              <option value="4">Challan</option>
              <option value="2">Online</option>
            </CSelect>
          </CCol>
        )} */}
      </CRow>
      <CRow>
        <FilterSection
          isDisabledSearchClear={props.isDisabledSearchClear}
          search={props.searchButton}
          clear={props.clearSearch}
          itemPerPage={props.itemPerPage}
          onChangePage={props.onChangePage}
          isExportToExcelDisplay={true}
          isExporting={props.isExporting}
          isDisabledExport={props.isDisabledExport}
          ExportToExcel={props.ExportToExcel}
        />
      </CRow>{" "}
    </div>
  );
};

export default SearchFilter;
